export const CLASS_NAMES = {
  container: 'flex flex-1 flex-row items-center',
  title: 'text-style-g-em text-neutral-900 mr-4',
  pounds: 'text-style-g-em text-neutral-900',
  cents: 'text-style-g-em text-neutral-900',
};
